import jwt from 'jsonwebtoken';
import { EncryptMe, envConfig } from '../_helpers';

export const userService = {
  signin,
  signup,
  validateUser,
  passwordRecovery
}

async function signin(user) {
  let encrypted = await EncryptMe(user);

  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'req-language': 'pt_BR'
    },
    body: JSON.stringify(encrypted)
  }

  return fetch(`${envConfig.MAIN_API_URL}/users/signin`, requestOptions)
    .then(async response => {
      if ( response.status !== 200 ) {
        return Promise.reject(await response.json());
      }
      return response.json();
    })
    .then(user => {
      if ( user && user.data ) {
        let decodedUser = jwt.decode(user.data.client);

        let modules = {};
        user.data.role.modules.map(module => {
          modules[module.name] = true
        })

        let userdata = {
          username: user.data.name,
          company_uuid: decodedUser.company,
          user_uuid: decodedUser.user,
          bearer_token: user.data.client,
          expire_date: user.data.cookie.expires,
          modules,
        }

        sessionStorage.setItem('cellit_userdata', JSON.stringify(userdata));
      }
    })
}

async function signup(user) {
  let encrypted = await EncryptMe(user);

  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'req-language': 'pt_BR'
    },
    body: JSON.stringify(encrypted)
  }

  const response = await fetch(`${envConfig.MAIN_API_URL}/users/signup`, requestOptions);
  return response.status !== 200 ? Promise.reject(await response.json()) : await response.json();
}

async function validateUser(data) {
  let encrypted = await EncryptMe(data);

  const requestOptions = {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      'req-language': 'pt_BR'
    },
    body: JSON.stringify(encrypted)
  }

  const response = await fetch(`${envConfig.MAIN_API_URL}/users/validate`, requestOptions);
  return response.status !== 200 ? Promise.reject(await response.json()) : await response.json();
}

async function passwordRecovery(data) {
  let encrypted = await EncryptMe(data);

  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'req-language': 'pt_BR'
    },
    body: JSON.stringify(encrypted)
  }

  const response = await fetch(`${envConfig.MAIN_API_URL}/users/signup`, requestOptions);
  return response.status !== 200 ? Promise.reject(await response.json()) : await response.json();
}
